module.exports = __webpack_public_path__ + "static/img/tangyuan.205a44cf.png";